export default __webpack_public_path__ + "static/media/(30).c8943d85.jpg";